<script>
  import AboutBusiness from './components/_business.svelte'
</script>

<div class="mt-[122px]">
  <AboutBusiness />
</div>
